import type { KeySlot } from '@tunasong/music-lib'
import { KEY_POOL } from '@tunasong/music-lib'

export type CofSubMode = 'explore' | 'quiz'

/**
 * Parses the `?mode=` URL param into the CoF sub-mode union. Unknown values
 * resolve to `null` so the host falls through to the welcome screen.
 *
 * Spec: docs/superpowers/specs/2026-05-23-cof-wheel-v1-design.md §11
 */
export const parseCofSubMode = (raw: string | null): CofSubMode | null => {
  if (raw === 'explore' || raw === 'quiz') {
    return raw
  }
  return null
}

/**
 * Parses the `?key=` URL param into a `KeySlot`, accepting either the sharp
 * canonical spelling or the flat enharmonic spelling (e.g. `Gb` → F# slot).
 */
export const parseCofKeyParam = (raw: string | null): KeySlot | null => {
  if (!raw) {
    return null
  }
  return KEY_POOL.find(slot => slot.majorLabels.includes(raw) || slot.canonical === raw) ?? null
}
